export default __webpack_public_path__ + "static/media/phishing-indentify4-en.f7a1f855.png";